import axios, { AxiosError, AxiosResponse } from 'axios'
import { ValidateResult, bankBranchCodeValidator, bankCodeValidator } from 'utilities/validators'

/**
 * 銀行くん 金融機関コード API
 * @param bankCode 銀行コード
 * @param completed 完了コールバック
 * @returns 銀行情報
 */
export const bankCodeLibrary = async (bankCode: string, completed: (name: string) => void) => {
  if (bankCodeValidator(bankCode) === ValidateResult.Valid) {
    const url = `https://bank.teraren.com/banks/${bankCode}.json`
    await axios
      .get(url)
      .then((response: AxiosResponse) => {
        if (response.data) {
          const result = response.data ?? {}
          if (result.name) {
            completed(result.name)
          }
        }
      })
      .catch((error: AxiosError) => {
        if (error.code !== 'ERR_NETWORK') {
          console.error(error)
        }
      })
  }
}

/**
 * 銀行くん 支店コード API
 * @param bankCode 銀行コード
 * @param bankBranchCode 銀行支店コード
 * @param completed 完了コールバック
 * @returns 銀行情報
 */
export const bankBranchCodeLibrary = async (bankCode: string, bankBranchCode: string, completed: (name: string) => void) => {
  if (bankCodeValidator(bankCode) === ValidateResult.Valid && bankBranchCodeValidator(bankBranchCode) === ValidateResult.Valid) {
    const url = `https://bank.teraren.com/banks/${bankCode}/branches/${bankBranchCode}.json`
    await axios
      .get(url)
      .then((response: AxiosResponse) => {
        if (response.data) {
          const result = response.data ?? {}
          if (result.name) {
            completed(result.name)
          }
        }
      })
      .catch((error: AxiosError) => {
        if (error.code !== 'ERR_NETWORK') {
          console.error(error)
        }
      })
  }
}
